require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./i-may-not-have-gone-2.json") })
        }
      }, "path---i-may-not-have-gone-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---i-may-not-have-gone-2!./.cache/json/i-may-not-have-gone-2.json
// module id = 833
// module chunks = 231608221292675